export default {
  gridTemplate: 'repeat(6, 1fr)',
  gridColumnGap: '0.5rem',
  gridMarginRight: '1rem',
  formTextColor: 'var(--black)',
  calculatorGridTemplate: '1fr',
  loanCalculatorPadding: '1.5rem',
};
